import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import Edit from "@material-ui/icons/Edit";
import Box from "@material-ui/core/Box";
// In AiDesignsTable.jsx

// Add imports
import AddIcon from "@material-ui/icons/Add";
import { AppFloatActionByn } from "../../components/AppFloatActionBtn";
import AiDesignFormDialog from "./AiDesignFormDialog";
import RegularButton from "../../components/CustomButtons/Button";
import AiDesignService from "../../services/AiDesignService.js";
import { SHOW_APP_ALERT } from "../../action-types";

export default function AiDesignsTable() {
  const dispatch = useDispatch();

  const [items, setItems] = useState([]);
  const [deleteAlert, setDeleteAlert] = useState({ show: false, id: null });
  const [publishAlert, setPublishAlert] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);

  useEffect(() => {
    getAllDesigns();
  }, []);

  const getAllDesigns = async () => {
    console.log("getAllDesigns");
    const data = await AiDesignService.getAllDesigns();
    console.log("data", data);
    setItems(
      data.map((item) => ({
        id: item.Id,
        name: item.Name,
        category: item.Category,
        prompt: item.Prompt,
        prompt_description: item.PromptDescription,
        rank: item.Rank * 1,
      }))
    );
  };

  const deleteDesign = (id) => {
    setDeleteAlert({ show: true, id });
  };

  const handleDeleteConfirm = async () => {
    setDeleteAlert({ show: false, id: null });
    const res = await AiDesignService.deleteDesign(deleteAlert.id);
    console.log("deleted", res);
    dispatch({
      type: SHOW_APP_ALERT,
      alertConfig: {
        type: "success",
        message: "AI design deleted successfully!",
      },
    });
    getAllDesigns();
  };

  const handleDeleteCancel = () => {
    setDeleteAlert({ show: false, id: null });
  };

  const handleEditOpen = (item) => {
    setEditingItem(item);
    setIsFormOpen(true);
  };
  const handleEditClose = () => {
    setEditingItem(null);
    setIsFormOpen(false);
  };
  // Add handler for form submission
  const handleFormSubmit = async (formData) => {
    try {
      if (editingItem && editingItem.id) {
        const res = await AiDesignService.editDesign(formData);
        console.log("res", res);
      } else {
        const res = await AiDesignService.createDesign(formData);
        console.log("res", res);
      }
      dispatch({
        type: SHOW_APP_ALERT,
        alertConfig: {
          type: "success",
          message: "AI Design saved successfully!",
        },
      });
      getAllDesigns();
    } catch (error) {
      console.error("Error creating design:", error);
      // Add error handling here (e.g., show an error message)
    }
  };

  const handlePublishConfirm = async () => {
    setPublishAlert(false);
    const res = await AiDesignService.publishDesign();
    dispatch({
      type: SHOW_APP_ALERT,
      alertConfig: {
        type: "success",
        message: "AI Designs published successfully!",
      },
    });
  };

  const handlePublishClick = () => {
    setPublishAlert(true);
  };
  return (
    <Box style={{ width: "100%", padding: "24px" }}>
      <Box
        mb={2}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "10px",
          width: "100%",
        }}
      >
        <RegularButton size={"sm"} onClick={handlePublishClick} color="info">
          Publish
        </RegularButton>
        <AppFloatActionByn color={"cyan"} onClick={() => setIsFormOpen(true)} />
      </Box>

      <div style={{ width: "100%", overflowX: "auto" }}>
        <Table style={{ width: "100%", minWidth: "650px" }}>
          <TableHead>
            <TableRow>
              <TableCell style={{fontWeight: "bold" }}>
                Rank
              </TableCell>
              <TableCell style={{ width: "10%", fontWeight: "bold" }}>
                Category
              </TableCell>
              <TableCell style={{ width: "10%", fontWeight: "bold" }}>
                Name
              </TableCell>
              <TableCell style={{fontWeight: "bold" }}>
                Prompt
              </TableCell>
              <TableCell style={{fontWeight: "bold" }}>
                Description
              </TableCell>
              <TableCell style={{ fontWeight: "bold" }}>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items &&
              items.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item.rank}</TableCell>
                  <TableCell>{item.category}</TableCell>
                  <TableCell>{item.name}</TableCell>
                  <TableCell>{item.prompt}</TableCell>
                  <TableCell>{item.prompt_description}</TableCell>
                  <TableCell>
                    <Box sx={{ display: "flex" }}>
                        
                        <IconButton onClick={() => deleteDesign(item.id)}>
                            <DeleteIcon />
                        </IconButton>
                        <IconButton onClick={() => handleEditOpen(item)}>
                            <Edit />
                        </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </div>

      {/* Add the form dialog */}
      <AiDesignFormDialog
        editData={editingItem}
        open={isFormOpen}
        onClose={handleEditClose}
        onSubmit={handleFormSubmit}
      />

      <SweetAlert
        warning
        title="Are you sure?"
        show={deleteAlert.show}
        showConfirm={false}
      >
        <Box>
          You will not be able to recover this design!
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              gap: "10px",
              mt: "10px",
            }}
          >
            <RegularButton
              size={"sm"}
              onClick={handleDeleteConfirm}
              color="info"
            >
              Yes, delete it!
            </RegularButton>
            <RegularButton
              size={"sm"}
              onClick={handleDeleteCancel}
              color="tumblr"
            >
              Cancel
            </RegularButton>
          </Box>
        </Box>
      </SweetAlert>

      <SweetAlert
        warning
        title="Are you sure?"
        show={publishAlert}
        showConfirm={false}
      >
        <Box>
          Do you want to publish all Designs?
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              gap: "10px",
              mt: "10px",
            }}
          >
            <RegularButton
              size={"sm"}
              onClick={handlePublishConfirm}
              color="info"
            >
              Yes, publish it!
            </RegularButton>
            <RegularButton
              size={"sm"}
              onClick={() => setPublishAlert(false)}
              color="tumblr"
            >
              Cancel
            </RegularButton>
          </Box>
        </Box>
      </SweetAlert>
    </Box>
  );
}
